import { ComponentEvents } from 'global/interfaces/component.interface';

export const MoleculeJobOfferSearchEvents: ComponentEvents = {
	clearButton: 'clearButton',
	inputChange: 'inputChange',
	searchText: 'searchText',
};

export interface MoleculeJobOfferSearchEvent {
	selects: {
		key: string;
		value: string
	}[]
	search?: string;
}
